module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-dialog', {
    attrs: {
      "value": _vm.value,
      "persistent": "",
      "max-width": "600"
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline grey lighten-2"
  }, [_vm._v("\n          Add contents to  "), _c('strong', [_vm._v(_vm._s(_vm.campaignData ? _vm.campaignData.name : ''))]), _vm._v(" \n        ")]), _vm._v(" "), _c('v-card-text', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12",
      "sm": "12",
      "lg": "12"
    }
  }, [_c('v-select', {
    staticClass: "mt-5 pt-5",
    attrs: {
      "items": _vm.postTypes,
      "item-text": "title",
      "item-value": "name",
      "label": "Content Type",
      "filled": "",
      "hide-details": ""
    },
    on: {
      "change": _vm.changeContentType
    },
    model: {
      value: (_vm.postType),
      callback: function($$v) {
        _vm.postType = $$v
      },
      expression: "postType"
    }
  })], 1)], 1), _vm._v(" "), _c('v-expansion-panels', {
    staticClass: "mt-5",
    attrs: {
      "multiple": ""
    },
    model: {
      value: (_vm.panel),
      callback: function($$v) {
        _vm.panel = $$v
      },
      expression: "panel"
    }
  }, [(_vm.showPanel === 'story') ? _c('v-expansion-panel', [_c('v-expansion-panel-header', [_c('p', {
    staticClass: "title"
  }, [_vm._v("Add Story Insights Manually")])]), _vm._v(" "), _c('v-expansion-panel-content', [_c('i', {
    staticClass: "subtitle"
  }, [_vm._v("This method is customised way of adding story insights.")]), _c('br'), _vm._v(" "), _c('v-row', {
    staticClass: "mt-1",
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [(_vm.campaignData.campaignType === _vm.campaignTypes.AOK) ? _c('v-combobox', {
    attrs: {
      "items": _vm.pairedInfluencers,
      "item-text": "instagramHandle",
      "item-value": _vm.getAccountOptionValue,
      "hide-details": "auto",
      "return-object": "",
      "label": "Influencers",
      "prefix": "@",
      "dense": "",
      "outlined": ""
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(ref) {
        var item = ref.item;

        return [(item.platform === 'xiaohongshu') ? _c('span', [_vm._v("\n                          " + _vm._s(item.fullName) + "\n                        ")]) : (item.instagramHandle) ? _c('span', [_vm._v("\n                          " + _vm._s(item.instagramHandle) + "\n                        ")]) : _c('span', [_vm._v("\n                          " + _vm._s(item) + "\n                        ")])]
      }
    }, {
      key: "item",
      fn: function(ref) {
        var item = ref.item;

        return [_c('social-handle-view', {
          attrs: {
            "divClassName": "d-inline",
            "isTikTok": item.platform === 'tiktok',
            "isInstagram": !item.platform || item.platform === 'instagram',
            "isYoutube": item.platform === 'youtube',
            "isFacebook": item.platform === 'facebook',
            "isLinkedIn": item.platform === 'linkedin',
            "isXiaohongshu": item.platform === 'xiaohongshu',
            "isOthers": item.platform === 'others',
            "otherHandle": item.instagramHandle,
            "tiktokHandle": item.instagramHandle,
            "instagramHandle": item.instagramHandle,
            "youtubeHandle": item.instagramHandle,
            "facebookHandle": item.instagramHandle,
            "linkedinHandle": item.linkedinHandle || item.instagramHandle,
            "xiaohongshuHandle": item.fullName
          }
        })]
      }
    }], null, false, 1795247707),
    model: {
      value: (_vm.storyIgHandle),
      callback: function($$v) {
        _vm.storyIgHandle = $$v
      },
      expression: "storyIgHandle"
    }
  }) : _c('v-autocomplete', {
    attrs: {
      "items": _vm.pairedInfluencers,
      "item-text": "instagramHandle",
      "item-value": _vm.getAccountOptionValue,
      "hide-details": "auto",
      "return-object": "",
      "label": "Influencers",
      "prefix": "@",
      "dense": "",
      "outlined": ""
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(ref) {
        var item = ref.item;

        return [(item.platform === 'xiaohongshu') ? _c('span', [_vm._v("\n                          " + _vm._s(item.fullName) + "\n                        ")]) : (item.instagramHandle) ? _c('span', [_vm._v("\n                          " + _vm._s(item.instagramHandle) + "\n                        ")]) : _c('span', [_vm._v("\n                          " + _vm._s(item) + "\n                        ")])]
      }
    }, {
      key: "item",
      fn: function(ref) {
        var item = ref.item;

        return [_c('social-handle-view', {
          attrs: {
            "divClassName": "d-inline",
            "isTikTok": item.platform === 'tiktok',
            "isInstagram": !item.platform || item.platform === 'instagram',
            "isYoutube": item.platform === 'youtube',
            "isFacebook": item.platform === 'facebook',
            "isLinkedIn": item.platform === 'linkedin',
            "isXiaohongshu": item.platform === 'xiaohongshu',
            "isOthers": item.platform === 'others',
            "otherHandle": item.instagramHandle,
            "tiktokHandle": item.instagramHandle,
            "instagramHandle": item.instagramHandle,
            "youtubeHandle": item.instagramHandle,
            "facebookHandle": item.instagramHandle,
            "linkedinHandle": item.linkedinHandle || item.instagramHandle,
            "xiaohongshuHandle": item.fullName
          }
        })]
      }
    }], null, false, 1795247707),
    model: {
      value: (_vm.storyIgHandle),
      callback: function($$v) {
        _vm.storyIgHandle = $$v
      },
      expression: "storyIgHandle"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.targetCountries,
      "item-text": "name",
      "item-value": "name",
      "label": "Country",
      "outlined": "",
      "dense": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.storyCountry),
      callback: function($$v) {
        _vm.storyCountry = $$v
      },
      expression: "storyCountry"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12",
      "xs": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Story Media URL"
    },
    model: {
      value: (_vm.storyMediaUrl),
      callback: function($$v) {
        _vm.storyMediaUrl = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "storyMediaUrl"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12",
      "xs": "12"
    }
  }, [_c('v-menu', {
    ref: "datePicker",
    attrs: {
      "close-on-content-click": false,
      "nudge-right": 40,
      "transition": "scale-transition",
      "offset-y": "",
      "min-width": "290px"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-text-field', _vm._g({
          attrs: {
            "placeholder": "Live Date",
            "append-icon": "event",
            "readonly": "",
            "dense": ""
          },
          model: {
            value: (_vm.storyLiveDate),
            callback: function($$v) {
              _vm.storyLiveDate = $$v
            },
            expression: "storyLiveDate"
          }
        }, on))]
      }
    }], null, false, 2503307858),
    model: {
      value: (_vm.storyLiveCal),
      callback: function($$v) {
        _vm.storyLiveCal = $$v
      },
      expression: "storyLiveCal"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "type": "date"
    },
    on: {
      "input": function($event) {
        _vm.storyLiveCal = false
      }
    },
    model: {
      value: (_vm.storyLiveDate),
      callback: function($$v) {
        _vm.storyLiveDate = $$v
      },
      expression: "storyLiveDate"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12",
      "xs": "12"
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "warning",
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.openUploadStatsDialog(_vm.storyIgHandle, 'story')
      }
    }
  }, [_vm._v("\n                      Upload Stats with AI\n                    ")])], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Accounts reached",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.storyInsights.reach),
      callback: function($$v) {
        _vm.$set(_vm.storyInsights, "reach", _vm._n($$v))
      },
      expression: "storyInsights.reach"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Impressions",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.storyInsights.impressions),
      callback: function($$v) {
        _vm.$set(_vm.storyInsights, "impressions", _vm._n($$v))
      },
      expression: "storyInsights.impressions"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Story Likes",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.storyInsights.story_likes),
      callback: function($$v) {
        _vm.$set(_vm.storyInsights, "story_likes", _vm._n($$v))
      },
      expression: "storyInsights.story_likes"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Replies",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.storyInsights.replies),
      callback: function($$v) {
        _vm.$set(_vm.storyInsights, "replies", _vm._n($$v))
      },
      expression: "storyInsights.replies"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Shares",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.storyInsights.shares),
      callback: function($$v) {
        _vm.$set(_vm.storyInsights, "shares", _vm._n($$v))
      },
      expression: "storyInsights.shares"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Link Clicks",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.storyInsights.link_clicks),
      callback: function($$v) {
        _vm.$set(_vm.storyInsights, "link_clicks", _vm._n($$v))
      },
      expression: "storyInsights.link_clicks"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Sticker Taps",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.storyInsights.sticker_taps),
      callback: function($$v) {
        _vm.$set(_vm.storyInsights, "sticker_taps", _vm._n($$v))
      },
      expression: "storyInsights.sticker_taps"
    }
  })], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    on: {
      "click": function($event) {
        return _vm.addStoryInsightsManually()
      }
    }
  }, [_vm._v("Add")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.showPanel === 'post') ? _c('v-expansion-panel', [_c('v-expansion-panel-header', [_c('p', {
    staticClass: "title"
  }, [_vm._v("Add Post Insights Manually")])]), _vm._v(" "), _c('v-expansion-panel-content', [_c('i', {
    staticClass: "subtitle"
  }, [_vm._v("This method is customised way of adding post insights.")]), _c('br'), _vm._v(" "), _c('v-row', {
    staticClass: "mt-1",
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [(_vm.campaignData.campaignType === _vm.campaignTypes.AOK) ? _c('v-combobox', {
    attrs: {
      "items": _vm.pairedInfluencers,
      "item-text": "instagramHandle",
      "item-value": _vm.getAccountOptionValue,
      "hide-details": "auto",
      "return-object": "",
      "label": "Influencers",
      "prefix": "@",
      "dense": "",
      "outlined": ""
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(ref) {
        var item = ref.item;

        return [(item.platform === 'xiaohongshu') ? _c('span', [_vm._v("\n                            " + _vm._s(item.fullName) + "\n                          ")]) : (item.instagramHandle) ? _c('span', [_vm._v("\n                            " + _vm._s(item.instagramHandle) + "\n                          ")]) : _c('span', [_vm._v("\n                            " + _vm._s(item) + "\n                          ")])]
      }
    }, {
      key: "item",
      fn: function(ref) {
        var item = ref.item;

        return [_c('social-handle-view', {
          attrs: {
            "divClassName": "d-inline",
            "isTikTok": item.platform === 'tiktok',
            "isInstagram": !item.platform || item.platform === 'instagram',
            "isYoutube": item.platform === 'youtube',
            "isFacebook": item.platform === 'facebook',
            "isLinkedIn": item.platform === 'linkedin',
            "isXiaohongshu": item.platform === 'xiaohongshu',
            "tiktokHandle": item.instagramHandle,
            "instagramHandle": item.instagramHandle,
            "youtubeHandle": item.instagramHandle,
            "facebookHandle": item.instagramHandle,
            "linkedinHandle": item.linkedinHandle || item.instagramHandle,
            "xiaohongshuHandle": item.fullName,
            "isOthers": item.platform === 'others',
            "otherHandle": item.instagramHandle
          }
        })]
      }
    }], null, false, 3631065275),
    model: {
      value: (_vm.postIgHandle),
      callback: function($$v) {
        _vm.postIgHandle = $$v
      },
      expression: "postIgHandle"
    }
  }) : _c('v-autocomplete', {
    attrs: {
      "items": _vm.pairedInfluencers,
      "item-text": "instagramHandle",
      "item-value": _vm.getAccountOptionValue,
      "hide-details": "auto",
      "return-object": "",
      "label": "Influencers",
      "prefix": "@",
      "dense": "",
      "outlined": ""
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(ref) {
        var item = ref.item;

        return [(item.platform === 'xiaohongshu') ? _c('span', [_vm._v("\n                            " + _vm._s(item.fullName) + "\n                          ")]) : (item.instagramHandle) ? _c('span', [_vm._v("\n                            " + _vm._s(item.instagramHandle) + "\n                          ")]) : _c('span', [_vm._v("\n                            " + _vm._s(item) + "\n                          ")])]
      }
    }, {
      key: "item",
      fn: function(ref) {
        var item = ref.item;

        return [_c('social-handle-view', {
          attrs: {
            "divClassName": "d-inline",
            "isTikTok": item.platform === 'tiktok',
            "isInstagram": !item.platform || item.platform === 'instagram',
            "isYoutube": item.platform === 'youtube',
            "isFacebook": item.platform === 'facebook',
            "isLinkedIn": item.platform === 'linkedin',
            "isXiaohongshu": item.platform === 'xiaohongshu',
            "tiktokHandle": item.instagramHandle,
            "instagramHandle": item.instagramHandle,
            "youtubeHandle": item.instagramHandle,
            "facebookHandle": item.instagramHandle,
            "linkedinHandle": item.linkedinHandle || item.instagramHandle,
            "xiaohongshuHandle": item.fullName,
            "isOthers": item.platform === 'others',
            "otherHandle": item.instagramHandle
          }
        })]
      }
    }], null, false, 3631065275),
    model: {
      value: (_vm.postIgHandle),
      callback: function($$v) {
        _vm.postIgHandle = $$v
      },
      expression: "postIgHandle"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.targetCountries,
      "item-text": "name",
      "item-value": "name",
      "label": "Country",
      "dense": "",
      "outlined": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.postCountry),
      callback: function($$v) {
        _vm.postCountry = $$v
      },
      expression: "postCountry"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12",
      "xs": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Post URL"
    },
    model: {
      value: (_vm.postURL),
      callback: function($$v) {
        _vm.postURL = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "postURL"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12",
      "xs": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Post Image URL",
      "placeholder": "Optional"
    },
    model: {
      value: (_vm.postImageURL),
      callback: function($$v) {
        _vm.postImageURL = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "postImageURL"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12",
      "xs": "12"
    }
  }, [_c('v-menu', {
    ref: "datePicker",
    attrs: {
      "close-on-content-click": false,
      "nudge-right": 40,
      "transition": "scale-transition",
      "offset-y": "",
      "min-width": "290px"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-text-field', _vm._g({
          attrs: {
            "placeholder": "Live Date",
            "append-icon": "event",
            "readonly": "",
            "dense": ""
          },
          model: {
            value: (_vm.postLiveDate),
            callback: function($$v) {
              _vm.postLiveDate = $$v
            },
            expression: "postLiveDate"
          }
        }, on))]
      }
    }], null, false, 1035117641),
    model: {
      value: (_vm.postLiveCal),
      callback: function($$v) {
        _vm.postLiveCal = $$v
      },
      expression: "postLiveCal"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "type": "date"
    },
    on: {
      "input": function($event) {
        _vm.postLiveCal = false
      }
    },
    model: {
      value: (_vm.postLiveDate),
      callback: function($$v) {
        _vm.postLiveDate = $$v
      },
      expression: "postLiveDate"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12",
      "xs": "12"
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "warning",
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.openUploadStatsDialog(_vm.postIgHandle, 'post')
      }
    }
  }, [_vm._v("\n                      Upload Stats with AI\n                    ")])], 1)], 1), _vm._v(" "), (_vm.postType === 'IGP' || _vm.postType === 'IGC') ? _c('div', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Accounts reached",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.inputtedInsights.reach),
      callback: function($$v) {
        _vm.$set(_vm.inputtedInsights, "reach", _vm._n($$v))
      },
      expression: "inputtedInsights.reach"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Impressions",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.inputtedInsights.impressions),
      callback: function($$v) {
        _vm.$set(_vm.inputtedInsights, "impressions", _vm._n($$v))
      },
      expression: "inputtedInsights.impressions"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Likes",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.postInsights.like_count),
      callback: function($$v) {
        _vm.$set(_vm.postInsights, "like_count", _vm._n($$v))
      },
      expression: "postInsights.like_count"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Shares",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.inputtedInsights.shares),
      callback: function($$v) {
        _vm.$set(_vm.inputtedInsights, "shares", _vm._n($$v))
      },
      expression: "inputtedInsights.shares"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Comments",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.postInsights.comment_count),
      callback: function($$v) {
        _vm.$set(_vm.postInsights, "comment_count", _vm._n($$v))
      },
      expression: "postInsights.comment_count"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Saves (Bookmarks)",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.inputtedInsights.saved),
      callback: function($$v) {
        _vm.$set(_vm.inputtedInsights, "saved", _vm._n($$v))
      },
      expression: "inputtedInsights.saved"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.postType === 'IGR') ? _c('div', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Accounts reached",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.inputtedInsights.reach),
      callback: function($$v) {
        _vm.$set(_vm.inputtedInsights, "reach", _vm._n($$v))
      },
      expression: "inputtedInsights.reach"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Plays (Views)",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.inputtedInsights.views),
      callback: function($$v) {
        _vm.$set(_vm.inputtedInsights, "views", _vm._n($$v))
      },
      expression: "inputtedInsights.views"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Likes",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.postInsights.like_count),
      callback: function($$v) {
        _vm.$set(_vm.postInsights, "like_count", _vm._n($$v))
      },
      expression: "postInsights.like_count"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Saves (Bookmarks)",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.inputtedInsights.saved),
      callback: function($$v) {
        _vm.$set(_vm.inputtedInsights, "saved", _vm._n($$v))
      },
      expression: "inputtedInsights.saved"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Shares",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.inputtedInsights.shares),
      callback: function($$v) {
        _vm.$set(_vm.inputtedInsights, "shares", _vm._n($$v))
      },
      expression: "inputtedInsights.shares"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Reposts",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.inputtedInsights.reposts),
      callback: function($$v) {
        _vm.$set(_vm.inputtedInsights, "reposts", _vm._n($$v))
      },
      expression: "inputtedInsights.reposts"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Comments",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.postInsights.comment_count),
      callback: function($$v) {
        _vm.$set(_vm.postInsights, "comment_count", _vm._n($$v))
      },
      expression: "postInsights.comment_count"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "ma-0 pa-0",
    staticStyle: {
      "margin-top": "-3px!important",
      "margin-bottom": "-45px!important"
    },
    attrs: {
      "xs12": "",
      "md12": ""
    }
  }, [_c('label', {
    staticStyle: {
      "font-weight": "normal",
      "font-size": "12px",
      "color": "rgba(0, 0, 0, 0.6)"
    }
  }, [_vm._v("Watch Time")])])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": "",
      "md3": "",
      "lg3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "d",
      "required": "",
      "type": "number",
      "min": "0"
    },
    model: {
      value: (_vm.reelTotalPlayTime.day),
      callback: function($$v) {
        _vm.$set(_vm.reelTotalPlayTime, "day", $$v)
      },
      expression: "reelTotalPlayTime.day"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": "",
      "md3": "",
      "lg3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "h",
      "required": "",
      "type": "number",
      "min": "0"
    },
    model: {
      value: (_vm.reelTotalPlayTime.hour),
      callback: function($$v) {
        _vm.$set(_vm.reelTotalPlayTime, "hour", $$v)
      },
      expression: "reelTotalPlayTime.hour"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": "",
      "md3": "",
      "lg3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "m",
      "required": "",
      "type": "number",
      "min": "0"
    },
    model: {
      value: (_vm.reelTotalPlayTime.minute),
      callback: function($$v) {
        _vm.$set(_vm.reelTotalPlayTime, "minute", $$v)
      },
      expression: "reelTotalPlayTime.minute"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": "",
      "md3": "",
      "lg3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "s",
      "required": "",
      "type": "number",
      "min": "0"
    },
    model: {
      value: (_vm.reelTotalPlayTime.second),
      callback: function($$v) {
        _vm.$set(_vm.reelTotalPlayTime, "second", $$v)
      },
      expression: "reelTotalPlayTime.second"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Average Watch Time",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.inputtedInsights.watches),
      callback: function($$v) {
        _vm.$set(_vm.inputtedInsights, "watches", $$v)
      },
      expression: "inputtedInsights.watches"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    on: {
      "click": function($event) {
        return _vm.addPostInsightsManually()
      }
    }
  }, [_vm._v("Add")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.showPanel === 'tiktok') ? _c('v-expansion-panel', [_c('v-expansion-panel-header', [_c('p', {
    staticClass: "title"
  }, [_vm._v("Add using TikTok URL")])]), _vm._v(" "), _c('v-expansion-panel-content', [_c('i', {
    staticClass: "subtitle"
  }, [_vm._v("This method is semi-customised way of adding Tiktok insights.")]), _c('br'), _vm._v(" "), _c('v-row', {
    staticClass: "mt-1",
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [(_vm.campaignData.campaignType === _vm.campaignTypes.AOK) ? _c('v-combobox', {
    attrs: {
      "items": _vm.pairedInfluencers,
      "item-text": "instagramHandle",
      "item-value": _vm.getAccountOptionValue,
      "hide-details": "auto",
      "return-object": "",
      "label": "Influencers",
      "prefix": "@",
      "dense": "",
      "outlined": ""
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(ref) {
        var item = ref.item;

        return [(item.platform === 'xiaohongshu') ? _c('span', [_vm._v("\n                          " + _vm._s(item.fullName) + "\n                        ")]) : (item.instagramHandle) ? _c('span', [_vm._v("\n                          " + _vm._s(item.instagramHandle) + "\n                        ")]) : _c('span', [_vm._v("\n                          " + _vm._s(item) + "\n                        ")])]
      }
    }, {
      key: "item",
      fn: function(ref) {
        var item = ref.item;

        return [_c('social-handle-view', {
          attrs: {
            "divClassName": "d-inline",
            "isTikTok": item.platform === 'tiktok',
            "isInstagram": !item.platform || item.platform === 'instagram',
            "isYoutube": item.platform === 'youtube',
            "isFacebook": item.platform === 'facebook',
            "isLinkedIn": item.platform === 'linkedin',
            "isXiaohongshu": item.platform === 'xiaohongshu',
            "tiktokHandle": item.instagramHandle,
            "instagramHandle": item.instagramHandle,
            "youtubeHandle": item.instagramHandle,
            "facebookHandle": item.instagramHandle,
            "linkedinHandle": item.linkedinHandle || item.instagramHandle,
            "xiaohongshuHandle": item.fullName,
            "isOthers": item.platform === 'others',
            "otherHandle": item.instagramHandle
          }
        })]
      }
    }], null, false, 2946995003),
    model: {
      value: (_vm.tikTokHandle),
      callback: function($$v) {
        _vm.tikTokHandle = $$v
      },
      expression: "tikTokHandle"
    }
  }) : _c('v-autocomplete', {
    attrs: {
      "items": _vm.pairedInfluencers,
      "item-text": "instagramHandle",
      "item-value": _vm.getAccountOptionValue,
      "hide-details": "auto",
      "return-object": "",
      "label": "Influencers",
      "prefix": "@",
      "dense": "",
      "outlined": ""
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(ref) {
        var item = ref.item;

        return [(item.platform === 'xiaohongshu') ? _c('span', [_vm._v("\n                          " + _vm._s(item.fullName) + "\n                        ")]) : (item.instagramHandle) ? _c('span', [_vm._v("\n                          " + _vm._s(item.instagramHandle) + "\n                        ")]) : _c('span', [_vm._v("\n                          " + _vm._s(item) + "\n                        ")])]
      }
    }, {
      key: "item",
      fn: function(ref) {
        var item = ref.item;

        return [_c('social-handle-view', {
          attrs: {
            "divClassName": "d-inline",
            "isTikTok": item.platform === 'tiktok',
            "isInstagram": !item.platform || item.platform === 'instagram',
            "isYoutube": item.platform === 'youtube',
            "isFacebook": item.platform === 'facebook',
            "isLinkedIn": item.platform === 'linkedin',
            "isXiaohongshu": item.platform === 'xiaohongshu',
            "tiktokHandle": item.instagramHandle,
            "instagramHandle": item.instagramHandle,
            "youtubeHandle": item.instagramHandle,
            "facebookHandle": item.instagramHandle,
            "linkedinHandle": item.linkedinHandle || item.instagramHandle,
            "xiaohongshuHandle": item.fullName,
            "isOthers": item.platform === 'others',
            "otherHandle": item.instagramHandle
          }
        })]
      }
    }], null, false, 2946995003),
    model: {
      value: (_vm.tikTokHandle),
      callback: function($$v) {
        _vm.tikTokHandle = $$v
      },
      expression: "tikTokHandle"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.targetCountries,
      "item-text": "name",
      "item-value": "name",
      "label": "Country",
      "dense": "",
      "outlined": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.tiktokCountry),
      callback: function($$v) {
        _vm.tiktokCountry = $$v
      },
      expression: "tiktokCountry"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12",
      "xs": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Post URL"
    },
    model: {
      value: (_vm.tikTokPostURL),
      callback: function($$v) {
        _vm.tikTokPostURL = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "tikTokPostURL"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12",
      "xs": "12"
    }
  }, [_c('v-menu', {
    ref: "datePicker",
    attrs: {
      "close-on-content-click": false,
      "nudge-right": 40,
      "transition": "scale-transition",
      "offset-y": "",
      "min-width": "290px"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-text-field', _vm._g({
          attrs: {
            "placeholder": "Live Date",
            "append-icon": "event",
            "readonly": "",
            "dense": ""
          },
          model: {
            value: (_vm.tiktokLiveDate),
            callback: function($$v) {
              _vm.tiktokLiveDate = $$v
            },
            expression: "tiktokLiveDate"
          }
        }, on))]
      }
    }], null, false, 4237074295),
    model: {
      value: (_vm.tiktokLiveCal),
      callback: function($$v) {
        _vm.tiktokLiveCal = $$v
      },
      expression: "tiktokLiveCal"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "type": "date"
    },
    on: {
      "input": function($event) {
        _vm.tiktokLiveCal = false
      }
    },
    model: {
      value: (_vm.tiktokLiveDate),
      callback: function($$v) {
        _vm.tiktokLiveDate = $$v
      },
      expression: "tiktokLiveDate"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12",
      "xs": "12"
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "warning",
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.openUploadStatsDialog(_vm.tikTokHandle, 'tiktok')
      }
    }
  }, [_vm._v("\n                      Upload Stats with AI\n                    ")])], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "ma-0 pa-0",
    staticStyle: {
      "margin-top": "-3px!important",
      "margin-bottom": "-45px!important"
    },
    attrs: {
      "xs12": "",
      "md12": ""
    }
  }, [_c('label', {
    staticStyle: {
      "font-weight": "normal",
      "font-size": "12px",
      "color": "rgba(0, 0, 0, 0.6)"
    }
  }, [_vm._v("Total Play Time")])])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": "",
      "md4": "",
      "lg4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "h",
      "required": "",
      "type": "number",
      "min": "0"
    },
    model: {
      value: (_vm.totalPlayTime.hour),
      callback: function($$v) {
        _vm.$set(_vm.totalPlayTime, "hour", $$v)
      },
      expression: "totalPlayTime.hour"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": "",
      "md4": "",
      "lg4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "m",
      "required": "",
      "type": "number",
      "min": "0"
    },
    model: {
      value: (_vm.totalPlayTime.minute),
      callback: function($$v) {
        _vm.$set(_vm.totalPlayTime, "minute", $$v)
      },
      expression: "totalPlayTime.minute"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": "",
      "md4": "",
      "lg4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "s",
      "required": "",
      "type": "number",
      "min": "0"
    },
    model: {
      value: (_vm.totalPlayTime.second),
      callback: function($$v) {
        _vm.$set(_vm.totalPlayTime, "second", $$v)
      },
      expression: "totalPlayTime.second"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Average Watch Time",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.tikTokInputtedInsights.watches),
      callback: function($$v) {
        _vm.$set(_vm.tikTokInputtedInsights, "watches", $$v)
      },
      expression: "tikTokInputtedInsights.watches"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Likes",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.tikTokInsights.like_count),
      callback: function($$v) {
        _vm.$set(_vm.tikTokInsights, "like_count", _vm._n($$v))
      },
      expression: "tikTokInsights.like_count"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Comments",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.tikTokInsights.comment_count),
      callback: function($$v) {
        _vm.$set(_vm.tikTokInsights, "comment_count", _vm._n($$v))
      },
      expression: "tikTokInsights.comment_count"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Shares",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.tikTokInsights.shares),
      callback: function($$v) {
        _vm.$set(_vm.tikTokInsights, "shares", _vm._n($$v))
      },
      expression: "tikTokInsights.shares"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Favourites (Bookmarks)",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.tikTokInputtedInsights.saved),
      callback: function($$v) {
        _vm.$set(_vm.tikTokInputtedInsights, "saved", _vm._n($$v))
      },
      expression: "tikTokInputtedInsights.saved"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Plays (Views)",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.tikTokInsights.views),
      callback: function($$v) {
        _vm.$set(_vm.tikTokInsights, "views", _vm._n($$v))
      },
      expression: "tikTokInsights.views"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Total viewers (Reach)",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.tikTokInputtedInsights.reach),
      callback: function($$v) {
        _vm.$set(_vm.tikTokInputtedInsights, "reach", _vm._n($$v))
      },
      expression: "tikTokInputtedInsights.reach"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Watched full video (%)",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.tikTokInputtedInsights.watchedFullVideo),
      callback: function($$v) {
        _vm.$set(_vm.tikTokInputtedInsights, "watchedFullVideo", _vm._n($$v))
      },
      expression: "tikTokInputtedInsights.watchedFullVideo"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Photo Views",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.tikTokInputtedInsights.photo_views),
      callback: function($$v) {
        _vm.$set(_vm.tikTokInputtedInsights, "photo_views", _vm._n($$v))
      },
      expression: "tikTokInputtedInsights.photo_views"
    }
  })], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    on: {
      "click": function($event) {
        return _vm.addTikTokInsightsManually()
      }
    }
  }, [_vm._v("Add")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.showPanel === 'youtube') ? _c('v-expansion-panel', [_c('v-expansion-panel-header', [_c('p', {
    staticClass: "title"
  }, [_vm._v("Add using Youtube URL")])]), _vm._v(" "), _c('v-expansion-panel-content', [_c('i', {
    staticClass: "subtitle"
  }, [_vm._v("This method is customised way of adding Youtube insights.")]), _c('br'), _vm._v(" "), _c('v-row', {
    staticClass: "mt-1",
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [(_vm.campaignData.campaignType === _vm.campaignTypes.AOK) ? _c('v-combobox', {
    attrs: {
      "items": _vm.pairedInfluencers,
      "item-text": "instagramHandle",
      "item-value": "instagramHandle",
      "hide-details": "auto",
      "label": "Influencers",
      "prefix": "@",
      "dense": "",
      "outlined": ""
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(ref) {
        var item = ref.item;

        return [(item.platform === 'xiaohongshu') ? _c('span', [_vm._v("\n                          " + _vm._s(item.fullName) + "\n                        ")]) : (item.instagramHandle) ? _c('span', [_vm._v("\n                          " + _vm._s(item.instagramHandle) + "\n                        ")]) : _c('span', [_vm._v("\n                          " + _vm._s(item) + "\n                        ")])]
      }
    }, {
      key: "item",
      fn: function(ref) {
        var item = ref.item;

        return [_c('social-handle-view', {
          attrs: {
            "divClassName": "d-inline",
            "isTikTok": item.platform === 'tiktok',
            "isInstagram": !item.platform || item.platform === 'instagram',
            "isYoutube": item.platform === 'youtube',
            "isFacebook": item.platform === 'facebook',
            "isLinkedIn": item.platform === 'linkedin',
            "isXiaohongshu": item.platform === 'xiaohongshu',
            "tiktokHandle": item.instagramHandle,
            "instagramHandle": item.instagramHandle,
            "youtubeHandle": item.instagramHandle,
            "facebookHandle": item.instagramHandle,
            "linkedinHandle": item.linkedinHandle || item.instagramHandle,
            "xiaohongshuHandle": item.fullName,
            "isOthers": item.platform === 'others',
            "otherHandle": item.instagramHandle
          }
        })]
      }
    }], null, false, 2946995003),
    model: {
      value: (_vm.youtubeHandle),
      callback: function($$v) {
        _vm.youtubeHandle = $$v
      },
      expression: "youtubeHandle"
    }
  }) : _c('v-autocomplete', {
    attrs: {
      "items": _vm.pairedInfluencers,
      "item-text": "instagramHandle",
      "item-value": "instagramHandle",
      "hide-details": "auto",
      "label": "Influencers",
      "prefix": "@",
      "dense": "",
      "outlined": ""
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(ref) {
        var item = ref.item;

        return [(item.platform === 'xiaohongshu') ? _c('span', [_vm._v("\n                          " + _vm._s(item.fullName) + "\n                        ")]) : (item.instagramHandle) ? _c('span', [_vm._v("\n                          " + _vm._s(item.instagramHandle) + "\n                        ")]) : _c('span', [_vm._v("\n                          " + _vm._s(item) + "\n                        ")])]
      }
    }, {
      key: "item",
      fn: function(ref) {
        var item = ref.item;

        return [_c('social-handle-view', {
          attrs: {
            "divClassName": "d-inline",
            "isTikTok": item.platform === 'tiktok',
            "isInstagram": !item.platform || item.platform === 'instagram',
            "isYoutube": item.platform === 'youtube',
            "isFacebook": item.platform === 'facebook',
            "isLinkedIn": item.platform === 'linkedin',
            "isXiaohongshu": item.platform === 'xiaohongshu',
            "tiktokHandle": item.instagramHandle,
            "instagramHandle": item.instagramHandle,
            "youtubeHandle": item.instagramHandle,
            "facebookHandle": item.instagramHandle,
            "linkedinHandle": item.linkedinHandle || item.instagramHandle,
            "xiaohongshuHandle": item.fullName,
            "isOthers": item.platform === 'others',
            "otherHandle": item.instagramHandle
          }
        })]
      }
    }], null, false, 2946995003),
    model: {
      value: (_vm.youtubeHandle),
      callback: function($$v) {
        _vm.youtubeHandle = $$v
      },
      expression: "youtubeHandle"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.targetCountries,
      "item-text": "name",
      "item-value": "name",
      "label": "Country",
      "dense": "",
      "outlined": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.youtubeCountry),
      callback: function($$v) {
        _vm.youtubeCountry = $$v
      },
      expression: "youtubeCountry"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12",
      "xs": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Youtube Video URL"
    },
    model: {
      value: (_vm.youtubeURL),
      callback: function($$v) {
        _vm.youtubeURL = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "youtubeURL"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12",
      "xs": "12"
    }
  }, [_c('v-menu', {
    ref: "datePicker",
    attrs: {
      "close-on-content-click": false,
      "nudge-right": 40,
      "transition": "scale-transition",
      "offset-y": "",
      "min-width": "290px"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-text-field', _vm._g({
          attrs: {
            "placeholder": "Live Date",
            "append-icon": "event",
            "readonly": "",
            "dense": ""
          },
          model: {
            value: (_vm.youtubeLiveDate),
            callback: function($$v) {
              _vm.youtubeLiveDate = $$v
            },
            expression: "youtubeLiveDate"
          }
        }, on))]
      }
    }], null, false, 3381681204),
    model: {
      value: (_vm.youtubeLiveCal),
      callback: function($$v) {
        _vm.youtubeLiveCal = $$v
      },
      expression: "youtubeLiveCal"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "type": "date"
    },
    on: {
      "input": function($event) {
        _vm.youtubeLiveCal = false
      }
    },
    model: {
      value: (_vm.youtubeLiveDate),
      callback: function($$v) {
        _vm.youtubeLiveDate = $$v
      },
      expression: "youtubeLiveDate"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Likes",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.youtubeInsights.like_count),
      callback: function($$v) {
        _vm.$set(_vm.youtubeInsights, "like_count", _vm._n($$v))
      },
      expression: "youtubeInsights.like_count"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Comments",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.youtubeInsights.comment_count),
      callback: function($$v) {
        _vm.$set(_vm.youtubeInsights, "comment_count", _vm._n($$v))
      },
      expression: "youtubeInsights.comment_count"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Views",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.youtubeInsights.views),
      callback: function($$v) {
        _vm.$set(_vm.youtubeInsights, "views", _vm._n($$v))
      },
      expression: "youtubeInsights.views"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Impressions",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.youtubeInputtedInsights.impressions),
      callback: function($$v) {
        _vm.$set(_vm.youtubeInputtedInsights, "impressions", _vm._n($$v))
      },
      expression: "youtubeInputtedInsights.impressions"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Unique Viewers",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.youtubeInputtedInsights.unique_viewers),
      callback: function($$v) {
        _vm.$set(_vm.youtubeInputtedInsights, "unique_viewers", _vm._n($$v))
      },
      expression: "youtubeInputtedInsights.unique_viewers"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Average Watch Time",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.youtubeInputtedInsights.watches),
      callback: function($$v) {
        _vm.$set(_vm.youtubeInputtedInsights, "watches", _vm._n($$v))
      },
      expression: "youtubeInputtedInsights.watches"
    }
  })], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    on: {
      "click": function($event) {
        return _vm.addYoutubeInsightsManually()
      }
    }
  }, [_vm._v("Add")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.showPanel === 'Others' || _vm.showPanel === 'LinkedIn Post' || _vm.showPanel === 'X (Twitter) Post') ? _c('v-expansion-panel', [_c('v-expansion-panel-header', [_c('p', {
    staticClass: "title"
  }, [_vm._v("Add using " + _vm._s(_vm.showPanel === 'LinkedIn Post' ? 'LinkedIn' : (_vm.showPanel === 'X (Twitter) Post' ? 'X (Twitter)' : 'Others')) + " URL")])]), _vm._v(" "), _c('v-expansion-panel-content', [_c('i', {
    staticClass: "subtitle"
  }, [_vm._v("This method is a customised way of adding " + _vm._s(_vm.showPanel === 'LinkedIn Post' ? 'LinkedIn' : (_vm.showPanel === 'X (Twitter) Post' ? 'X (Twitter)' : 'other platform')) + " insights.")]), _c('br'), _vm._v(" "), _c('v-row', {
    staticClass: "mt-1",
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [(_vm.campaignData.campaignType === _vm.campaignTypes.AOK) ? _c('v-combobox', {
    attrs: {
      "items": _vm.otherInfluencers,
      "item-text": "displayHandle",
      "item-value": "displayHandle",
      "return-object": "",
      "loading": _vm.pairedInfluencersLoading,
      "hide-details": "auto",
      "label": "Influencers",
      "prefix": "@",
      "dense": "",
      "outlined": ""
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(ref) {
        var item = ref.item;

        return [(item.platform === 'xiaohongshu') ? _c('span', [_vm._v("\n                          " + _vm._s(item.fullName) + "\n                        ")]) : (item.displayHandle) ? _c('span', [_vm._v("\n                          " + _vm._s(item.displayHandle) + "\n                        ")]) : _c('span', [_vm._v("\n                          " + _vm._s(item) + "\n                        ")])]
      }
    }, {
      key: "item",
      fn: function(ref) {
        var item = ref.item;

        return [_c('social-handle-view', {
          attrs: {
            "divClassName": "d-inline",
            "isTikTok": item.platform === 'tiktok',
            "isInstagram": !item.platform || item.platform === 'instagram',
            "isYoutube": item.platform === 'youtube',
            "isFacebook": item.platform === 'facebook',
            "isLinkedIn": item.platform === 'linkedin',
            "isTwitter": item.platform === 'twitter',
            "isXiaohongshu": item.platform === 'xiaohongshu',
            "tiktokHandle": item.instagramHandle,
            "instagramHandle": item.instagramHandle,
            "youtubeHandle": item.instagramHandle,
            "facebookHandle": item.instagramHandle,
            "linkedinHandle": item.linkedinHandle || item.instagramHandle,
            "twitterHandle": item.twitterHandle || item.instagramHandle,
            "xiaohongshuHandle": item.fullName,
            "isOthers": item.platform === 'others',
            "otherHandle": item.instagramHandle
          }
        })]
      }
    }], null, false, 489606698),
    model: {
      value: (_vm.otherHandle),
      callback: function($$v) {
        _vm.otherHandle = $$v
      },
      expression: "otherHandle"
    }
  }) : _c('v-autocomplete', {
    attrs: {
      "items": _vm.otherInfluencers,
      "item-text": "displayHandle",
      "item-value": "displayHandle",
      "return-object": "",
      "loading": _vm.pairedInfluencersLoading,
      "hide-details": "auto",
      "label": "Influencers",
      "prefix": "@",
      "dense": "",
      "outlined": ""
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(ref) {
        var item = ref.item;

        return [(item.platform === 'xiaohongshu') ? _c('span', [_vm._v("\n                          " + _vm._s(item.fullName) + "\n                        ")]) : (item.displayHandle) ? _c('span', [_vm._v("\n                          " + _vm._s(item.displayHandle) + "\n                        ")]) : _c('span', [_vm._v("\n                          " + _vm._s(item) + "\n                        ")])]
      }
    }, {
      key: "item",
      fn: function(ref) {
        var item = ref.item;

        return [_c('social-handle-view', {
          attrs: {
            "divClassName": "d-inline",
            "isTikTok": item.platform === 'tiktok',
            "isInstagram": !item.platform || item.platform === 'instagram',
            "isYoutube": item.platform === 'youtube',
            "isFacebook": item.platform === 'facebook',
            "isLinkedIn": item.platform === 'linkedin',
            "isTwitter": item.platform === 'twitter',
            "isXiaohongshu": item.platform === 'xiaohongshu',
            "tiktokHandle": item.instagramHandle,
            "instagramHandle": item.instagramHandle,
            "youtubeHandle": item.instagramHandle,
            "facebookHandle": item.instagramHandle,
            "linkedinHandle": item.linkedinHandle || item.instagramHandle,
            "twitterHandle": item.twitterHandle || item.instagramHandle,
            "xiaohongshuHandle": item.fullName,
            "isOthers": item.platform === 'others',
            "otherHandle": item.instagramHandle
          }
        })]
      }
    }], null, false, 489606698),
    model: {
      value: (_vm.otherHandle),
      callback: function($$v) {
        _vm.otherHandle = $$v
      },
      expression: "otherHandle"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.targetCountries,
      "item-text": "name",
      "item-value": "name",
      "label": "Country",
      "dense": "",
      "outlined": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.otherCountry),
      callback: function($$v) {
        _vm.otherCountry = $$v
      },
      expression: "otherCountry"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12",
      "xs": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Post URL"
    },
    model: {
      value: (_vm.otherPostURL),
      callback: function($$v) {
        _vm.otherPostURL = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "otherPostURL"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12",
      "xs": "12"
    }
  }, [_c('upload-media', {
    attrs: {
      "accept": "*",
      "listMedia": _vm.media,
      "influencer": _vm.influencer,
      "campaign": _vm.campaignData
    },
    on: {
      "change": _vm.otherMediaChanged
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12",
      "xs": "12"
    }
  }, [_c('v-menu', {
    ref: "datePicker",
    attrs: {
      "close-on-content-click": false,
      "nudge-right": 40,
      "transition": "scale-transition",
      "offset-y": "",
      "min-width": "290px"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-text-field', _vm._g({
          attrs: {
            "placeholder": "Live Date",
            "append-icon": "event",
            "readonly": "",
            "dense": ""
          },
          model: {
            value: (_vm.otherLiveDate),
            callback: function($$v) {
              _vm.otherLiveDate = $$v
            },
            expression: "otherLiveDate"
          }
        }, on))]
      }
    }], null, false, 3894645781),
    model: {
      value: (_vm.otherLiveCal),
      callback: function($$v) {
        _vm.otherLiveCal = $$v
      },
      expression: "otherLiveCal"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "type": "date"
    },
    on: {
      "input": function($event) {
        _vm.otherLiveCal = false
      }
    },
    model: {
      value: (_vm.otherLiveDate),
      callback: function($$v) {
        _vm.otherLiveDate = $$v
      },
      expression: "otherLiveDate"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-row', [(_vm.showPanel !== 'LinkedIn Post' && _vm.showPanel !== 'X (Twitter) Post') ? _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "ma-0 pa-0",
    staticStyle: {
      "margin-top": "-3px!important",
      "margin-bottom": "-45px!important"
    },
    attrs: {
      "xs12": "",
      "md12": ""
    }
  }, [_c('label', {
    staticStyle: {
      "font-weight": "normal",
      "font-size": "12px",
      "color": "rgba(0, 0, 0, 0.6)"
    }
  }, [_vm._v("Total Play Time")])])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": "",
      "md4": "",
      "lg4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "h",
      "required": "",
      "type": "number",
      "min": "0"
    },
    model: {
      value: (_vm.otherTotalPlayTime.hour),
      callback: function($$v) {
        _vm.$set(_vm.otherTotalPlayTime, "hour", $$v)
      },
      expression: "otherTotalPlayTime.hour"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": "",
      "md4": "",
      "lg4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "m",
      "required": "",
      "type": "number",
      "min": "0"
    },
    model: {
      value: (_vm.otherTotalPlayTime.minute),
      callback: function($$v) {
        _vm.$set(_vm.otherTotalPlayTime, "minute", $$v)
      },
      expression: "otherTotalPlayTime.minute"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": "",
      "md4": "",
      "lg4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "s",
      "required": "",
      "type": "number",
      "min": "0"
    },
    model: {
      value: (_vm.otherTotalPlayTime.second),
      callback: function($$v) {
        _vm.$set(_vm.otherTotalPlayTime, "second", $$v)
      },
      expression: "otherTotalPlayTime.second"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.showPanel !== 'LinkedIn Post' && _vm.showPanel !== 'X (Twitter) Post') ? _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Average Watch Time",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.otherInsights.watches),
      callback: function($$v) {
        _vm.$set(_vm.otherInsights, "watches", $$v)
      },
      expression: "otherInsights.watches"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showPanel === 'LinkedIn Post') ? _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "subtitle-1 font-weight-bold"
  }, [_vm._v("Discovery")])]) : _vm._e(), _vm._v(" "), (_vm.showPanel === 'LinkedIn Post' || _vm.showPanel === 'X (Twitter) Post') ? _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Impressions",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.otherInsights.impressions),
      callback: function($$v) {
        _vm.$set(_vm.otherInsights, "impressions", _vm._n($$v))
      },
      expression: "otherInsights.impressions"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showPanel === 'LinkedIn Post') ? _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Members reached",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.otherInsights.reach),
      callback: function($$v) {
        _vm.$set(_vm.otherInsights, "reach", _vm._n($$v))
      },
      expression: "otherInsights.reach"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showPanel === 'LinkedIn Post') ? _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('div', {
    staticClass: "subtitle-1 font-weight-bold mb-2"
  }, [_vm._v("Video Performance")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Video views",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.otherInsights.video_views),
      callback: function($$v) {
        _vm.$set(_vm.otherInsights, "video_views", _vm._n($$v))
      },
      expression: "otherInsights.video_views"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showPanel === 'LinkedIn Post') ? _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('div', {
    staticClass: "subtitle-1 font-weight-bold mb-2"
  }, [_vm._v("Profile Activity")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Profile viewers from this post",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.otherInsights.profile_viewers),
      callback: function($$v) {
        _vm.$set(_vm.otherInsights, "profile_viewers", _vm._n($$v))
      },
      expression: "otherInsights.profile_viewers"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showPanel === 'LinkedIn Post') ? _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "subtitle-1 font-weight-bold"
  }, [_vm._v("Engagement")])]) : _vm._e(), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.showPanel === 'LinkedIn Post' ? 'Reactions' : 'Likes',
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.otherInsights.like_count),
      callback: function($$v) {
        _vm.$set(_vm.otherInsights, "like_count", _vm._n($$v))
      },
      expression: "otherInsights.like_count"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.showPanel === 'X (Twitter) Post' ? 'Replies' : 'Comments',
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.otherInsights.comment_count),
      callback: function($$v) {
        _vm.$set(_vm.otherInsights, "comment_count", _vm._n($$v))
      },
      expression: "otherInsights.comment_count"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.showPanel === 'LinkedIn Post' || _vm.showPanel === 'X (Twitter) Post' ? 'Reposts' : 'Shares',
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.otherInsights.shares),
      callback: function($$v) {
        _vm.$set(_vm.otherInsights, "shares", _vm._n($$v))
      },
      expression: "otherInsights.shares"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.showPanel === 'LinkedIn Post' ? 'Saves' : (_vm.showPanel === 'X (Twitter) Post' ? 'Bookmarks' : 'Favourites (Bookmarks)'),
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.otherInsights.saved),
      callback: function($$v) {
        _vm.$set(_vm.otherInsights, "saved", _vm._n($$v))
      },
      expression: "otherInsights.saved"
    }
  })], 1), _vm._v(" "), (_vm.showPanel !== 'LinkedIn Post' && _vm.showPanel !== 'X (Twitter) Post') ? _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.showPanel === 'X (Twitter) Post' ? 'Views' : 'Plays (Views)',
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.otherInsights.views),
      callback: function($$v) {
        _vm.$set(_vm.otherInsights, "views", _vm._n($$v))
      },
      expression: "otherInsights.views"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showPanel !== 'LinkedIn Post' && _vm.showPanel !== 'X (Twitter) Post') ? _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Total viewers (Reach)",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.otherInsights.reach),
      callback: function($$v) {
        _vm.$set(_vm.otherInsights, "reach", _vm._n($$v))
      },
      expression: "otherInsights.reach"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    on: {
      "click": function($event) {
        return _vm.addOtherInsightsManually()
      }
    }
  }, [_vm._v("Add")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.showPanel === 'Facebook Post') ? _c('v-expansion-panel', [_c('v-expansion-panel-header', [_c('p', {
    staticClass: "title"
  }, [_vm._v("Add Facebook Insights Manually")])]), _vm._v(" "), _c('v-expansion-panel-content', [_c('i', {
    staticClass: "subtitle"
  }, [_vm._v("This method is customised way of adding facebook insights.")]), _c('br'), _vm._v(" "), _c('v-row', {
    staticClass: "mt-1",
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [(_vm.campaignData.campaignType === _vm.campaignTypes.AOK) ? _c('v-combobox', {
    attrs: {
      "items": _vm.pairedInfluencers,
      "item-text": "instagramHandle",
      "item-value": "instagramHandle",
      "hide-details": "auto",
      "label": "Influencers",
      "prefix": "@",
      "dense": "",
      "outlined": ""
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(ref) {
        var item = ref.item;

        return [(item.platform === 'xiaohongshu') ? _c('span', [_vm._v("\n                          " + _vm._s(item.fullName) + "\n                        ")]) : (item.instagramHandle) ? _c('span', [_vm._v("\n                          " + _vm._s(item.instagramHandle) + "\n                        ")]) : _c('span', [_vm._v("\n                          " + _vm._s(item) + "\n                        ")])]
      }
    }, {
      key: "item",
      fn: function(ref) {
        var item = ref.item;

        return [_c('social-handle-view', {
          attrs: {
            "divClassName": "d-inline",
            "isTikTok": item.platform === 'tiktok',
            "isInstagram": !item.platform || item.platform === 'instagram',
            "isYoutube": item.platform === 'youtube',
            "isFacebook": item.platform === 'facebook',
            "isLinkedIn": item.platform === 'linkedin',
            "isXiaohongshu": item.platform === 'xiaohongshu',
            "tiktokHandle": item.instagramHandle,
            "instagramHandle": item.instagramHandle,
            "youtubeHandle": item.instagramHandle,
            "facebookHandle": item.instagramHandle,
            "linkedinHandle": item.linkedinHandle || item.instagramHandle,
            "xiaohongshuHandle": item.fullName,
            "isOthers": item.platform === 'others',
            "otherHandle": item.instagramHandle
          }
        })]
      }
    }], null, false, 2946995003),
    model: {
      value: (_vm.fbHandle),
      callback: function($$v) {
        _vm.fbHandle = $$v
      },
      expression: "fbHandle"
    }
  }) : _c('v-autocomplete', {
    attrs: {
      "items": _vm.pairedInfluencers,
      "item-text": "instagramHandle",
      "item-value": "instagramHandle",
      "hide-details": "auto",
      "label": "Influencers",
      "prefix": "@",
      "dense": "",
      "outlined": ""
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(ref) {
        var item = ref.item;

        return [(item.platform === 'xiaohongshu') ? _c('span', [_vm._v("\n                          " + _vm._s(item.fullName) + "\n                        ")]) : (item.instagramHandle) ? _c('span', [_vm._v("\n                          " + _vm._s(item.instagramHandle) + "\n                        ")]) : _c('span', [_vm._v("\n                          " + _vm._s(item) + "\n                        ")])]
      }
    }, {
      key: "item",
      fn: function(ref) {
        var item = ref.item;

        return [_c('social-handle-view', {
          attrs: {
            "divClassName": "d-inline",
            "isTikTok": item.platform === 'tiktok',
            "isInstagram": !item.platform || item.platform === 'instagram',
            "isYoutube": item.platform === 'youtube',
            "isFacebook": item.platform === 'facebook',
            "isLinkedIn": item.platform === 'linkedin',
            "isXiaohongshu": item.platform === 'xiaohongshu',
            "tiktokHandle": item.instagramHandle,
            "instagramHandle": item.instagramHandle,
            "youtubeHandle": item.instagramHandle,
            "facebookHandle": item.instagramHandle,
            "linkedinHandle": item.linkedinHandle || item.instagramHandle,
            "xiaohongshuHandle": item.fullName,
            "isOthers": item.platform === 'others',
            "otherHandle": item.instagramHandle
          }
        })]
      }
    }], null, false, 2946995003),
    model: {
      value: (_vm.fbHandle),
      callback: function($$v) {
        _vm.fbHandle = $$v
      },
      expression: "fbHandle"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.targetCountries,
      "item-text": "name",
      "item-value": "name",
      "label": "Country",
      "dense": "",
      "outlined": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.fbCountry),
      callback: function($$v) {
        _vm.fbCountry = $$v
      },
      expression: "fbCountry"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12",
      "xs": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Facebook Media URL"
    },
    model: {
      value: (_vm.fbMediaUrl),
      callback: function($$v) {
        _vm.fbMediaUrl = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "fbMediaUrl"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12",
      "xs": "12"
    }
  }, [_c('v-menu', {
    ref: "datePicker",
    attrs: {
      "close-on-content-click": false,
      "nudge-right": 40,
      "transition": "scale-transition",
      "offset-y": "",
      "min-width": "290px"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-text-field', _vm._g({
          attrs: {
            "placeholder": "Live Date",
            "append-icon": "event",
            "readonly": "",
            "dense": ""
          },
          model: {
            value: (_vm.fbLiveDate),
            callback: function($$v) {
              _vm.fbLiveDate = $$v
            },
            expression: "fbLiveDate"
          }
        }, on))]
      }
    }], null, false, 2923034869),
    model: {
      value: (_vm.fbLiveCal),
      callback: function($$v) {
        _vm.fbLiveCal = $$v
      },
      expression: "fbLiveCal"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "type": "date"
    },
    on: {
      "input": function($event) {
        _vm.fbLiveCal = false
      }
    },
    model: {
      value: (_vm.fbLiveDate),
      callback: function($$v) {
        _vm.fbLiveDate = $$v
      },
      expression: "fbLiveDate"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Outreach",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.fbInsights.outreach),
      callback: function($$v) {
        _vm.$set(_vm.fbInsights, "outreach", _vm._n($$v))
      },
      expression: "fbInsights.outreach"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Likes",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.fbInsights.like_count),
      callback: function($$v) {
        _vm.$set(_vm.fbInsights, "like_count", _vm._n($$v))
      },
      expression: "fbInsights.like_count"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Comments",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.fbInsights.comment_count),
      callback: function($$v) {
        _vm.$set(_vm.fbInsights, "comment_count", _vm._n($$v))
      },
      expression: "fbInsights.comment_count"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Views",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.fbInsights.views),
      callback: function($$v) {
        _vm.$set(_vm.fbInsights, "views", _vm._n($$v))
      },
      expression: "fbInsights.views"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Shares",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.fbInsights.shares),
      callback: function($$v) {
        _vm.$set(_vm.fbInsights, "shares", _vm._n($$v))
      },
      expression: "fbInsights.shares"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Bookmarks",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.fbInsights.bookmarks),
      callback: function($$v) {
        _vm.$set(_vm.fbInsights, "bookmarks", _vm._n($$v))
      },
      expression: "fbInsights.bookmarks"
    }
  })], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    on: {
      "click": function($event) {
        return _vm.addFbInsightsManually()
      }
    }
  }, [_vm._v("Add")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.showPanel === 'XHS Post') ? _c('v-expansion-panel', [_c('v-expansion-panel-header', [_c('p', {
    staticClass: "title"
  }, [_vm._v("Add XHS Insights Manually")])]), _vm._v(" "), _c('v-expansion-panel-content', [_c('i', {
    staticClass: "subtitle"
  }, [_vm._v("This method is customised way of adding XHS insights.")]), _c('br'), _vm._v(" "), _c('v-row', {
    staticClass: "mt-1",
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [(_vm.campaignData.campaignType === _vm.campaignTypes.AOK) ? _c('v-combobox', {
    attrs: {
      "items": _vm.pairedInfluencers,
      "item-text": "instagramHandle",
      "item-value": "instagramHandle",
      "hide-details": "auto",
      "label": "Influencers",
      "prefix": "@",
      "dense": "",
      "outlined": ""
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(ref) {
        var item = ref.item;

        return [(item.platform === 'xiaohongshu') ? _c('span', [_vm._v("\n                          " + _vm._s(item.fullName) + "\n                        ")]) : (item.instagramHandle) ? _c('span', [_vm._v("\n                          " + _vm._s(item.instagramHandle) + "\n                        ")]) : _c('span', [_vm._v("\n                          " + _vm._s(item) + "\n                        ")])]
      }
    }, {
      key: "item",
      fn: function(ref) {
        var item = ref.item;

        return [_c('social-handle-view', {
          attrs: {
            "divClassName": "d-inline",
            "isTikTok": item.platform === 'tiktok',
            "isInstagram": !item.platform || item.platform === 'instagram',
            "isYoutube": item.platform === 'youtube',
            "isFacebook": item.platform === 'facebook',
            "isLinkedIn": item.platform === 'linkedin',
            "isXiaohongshu": item.platform === 'xiaohongshu',
            "tiktokHandle": item.instagramHandle,
            "instagramHandle": item.instagramHandle,
            "youtubeHandle": item.instagramHandle,
            "facebookHandle": item.instagramHandle,
            "linkedinHandle": item.linkedinHandle || item.instagramHandle,
            "xiaohongshuHandle": item.fullName,
            "isOthers": item.platform === 'others',
            "otherHandle": item.instagramHandle
          }
        })]
      }
    }], null, false, 2946995003),
    model: {
      value: (_vm.xhsHandle),
      callback: function($$v) {
        _vm.xhsHandle = $$v
      },
      expression: "xhsHandle"
    }
  }) : _c('v-autocomplete', {
    attrs: {
      "items": _vm.pairedInfluencers,
      "item-text": "instagramHandle",
      "item-value": "instagramHandle",
      "hide-details": "auto",
      "label": "Influencers",
      "prefix": "@",
      "dense": "",
      "outlined": ""
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(ref) {
        var item = ref.item;

        return [(item.platform === 'xiaohongshu') ? _c('span', [_vm._v("\n                          " + _vm._s(item.fullName) + "\n                        ")]) : (item.instagramHandle) ? _c('span', [_vm._v("\n                          " + _vm._s(item.instagramHandle) + "\n                        ")]) : _c('span', [_vm._v("\n                          " + _vm._s(item) + "\n                        ")])]
      }
    }, {
      key: "item",
      fn: function(ref) {
        var item = ref.item;

        return [_c('social-handle-view', {
          attrs: {
            "divClassName": "d-inline",
            "isTikTok": item.platform === 'tiktok',
            "isInstagram": !item.platform || item.platform === 'instagram',
            "isYoutube": item.platform === 'youtube',
            "isFacebook": item.platform === 'facebook',
            "isLinkedIn": item.platform === 'linkedin',
            "isXiaohongshu": item.platform === 'xiaohongshu',
            "tiktokHandle": item.instagramHandle,
            "instagramHandle": item.instagramHandle,
            "youtubeHandle": item.instagramHandle,
            "facebookHandle": item.instagramHandle,
            "linkedinHandle": item.linkedinHandle || item.instagramHandle,
            "xiaohongshuHandle": item.fullName,
            "isOthers": item.platform === 'others',
            "otherHandle": item.instagramHandle
          }
        })]
      }
    }], null, false, 2946995003),
    model: {
      value: (_vm.xhsHandle),
      callback: function($$v) {
        _vm.xhsHandle = $$v
      },
      expression: "xhsHandle"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.targetCountries,
      "item-text": "name",
      "item-value": "name",
      "label": "Country",
      "dense": "",
      "outlined": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.xhsCountry),
      callback: function($$v) {
        _vm.xhsCountry = $$v
      },
      expression: "xhsCountry"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12",
      "xs": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "XHS Link"
    },
    model: {
      value: (_vm.xhsLink),
      callback: function($$v) {
        _vm.xhsLink = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "xhsLink"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12",
      "xs": "12"
    }
  }, [_c('upload-media', {
    attrs: {
      "accept": "*",
      "listMedia": _vm.media,
      "influencer": _vm.influencer,
      "campaign": _vm.campaignData
    },
    on: {
      "change": _vm.xhsMediaChanged
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12",
      "xs": "12"
    }
  }, [_c('v-menu', {
    ref: "datePicker",
    attrs: {
      "close-on-content-click": false,
      "nudge-right": 40,
      "transition": "scale-transition",
      "offset-y": "",
      "min-width": "290px"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-text-field', _vm._g({
          attrs: {
            "placeholder": "Live Date",
            "append-icon": "event",
            "readonly": "",
            "dense": ""
          },
          model: {
            value: (_vm.xhsLiveDate),
            callback: function($$v) {
              _vm.xhsLiveDate = $$v
            },
            expression: "xhsLiveDate"
          }
        }, on))]
      }
    }], null, false, 2295750034),
    model: {
      value: (_vm.xhsLiveCal),
      callback: function($$v) {
        _vm.xhsLiveCal = $$v
      },
      expression: "xhsLiveCal"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "type": "date"
    },
    on: {
      "input": function($event) {
        _vm.xhsLiveCal = false
      }
    },
    model: {
      value: (_vm.xhsLiveDate),
      callback: function($$v) {
        _vm.xhsLiveDate = $$v
      },
      expression: "xhsLiveDate"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12",
      "xs": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "type": "number",
      "label": "Followers"
    },
    model: {
      value: (_vm.xhsFollowers),
      callback: function($$v) {
        _vm.xhsFollowers = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "xhsFollowers"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Views",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.xhsInsights.views),
      callback: function($$v) {
        _vm.$set(_vm.xhsInsights, "views", _vm._n($$v))
      },
      expression: "xhsInsights.views"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Average Watch Time",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.xhsInsights.watches),
      callback: function($$v) {
        _vm.$set(_vm.xhsInsights, "watches", $$v)
      },
      expression: "xhsInsights.watches"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Likes",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.xhsInsights.like_count),
      callback: function($$v) {
        _vm.$set(_vm.xhsInsights, "like_count", _vm._n($$v))
      },
      expression: "xhsInsights.like_count"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Saves",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.xhsInsights.bookmarks),
      callback: function($$v) {
        _vm.$set(_vm.xhsInsights, "bookmarks", _vm._n($$v))
      },
      expression: "xhsInsights.bookmarks"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Comments",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.xhsInsights.comment_count),
      callback: function($$v) {
        _vm.$set(_vm.xhsInsights, "comment_count", _vm._n($$v))
      },
      expression: "xhsInsights.comment_count"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Shares",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.xhsInsights.shares),
      callback: function($$v) {
        _vm.$set(_vm.xhsInsights, "shares", _vm._n($$v))
      },
      expression: "xhsInsights.shares"
    }
  })], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    on: {
      "click": function($event) {
        return _vm.addXHSInsightsManually()
      }
    }
  }, [_vm._v("Add")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.showPanel === 'Lemon Post') ? _c('v-expansion-panel', [_c('v-expansion-panel-header', [_c('p', {
    staticClass: "title"
  }, [_vm._v("Add Lemon8 Insights Manually")])]), _vm._v(" "), _c('v-expansion-panel-content', [_c('i', {
    staticClass: "subtitle"
  }, [_vm._v("This method is customised way of adding XHS insights.")]), _c('br'), _vm._v(" "), _c('v-row', {
    staticClass: "mt-1",
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [(_vm.campaignData.campaignType === _vm.campaignTypes.AOK) ? _c('v-combobox', {
    attrs: {
      "items": _vm.pairedInfluencers,
      "item-text": "instagramHandle",
      "item-value": "instagramHandle",
      "hide-details": "auto",
      "label": "Influencers",
      "prefix": "@",
      "dense": "",
      "outlined": ""
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(ref) {
        var item = ref.item;

        return [(item.platform === 'lemon8') ? _c('span', [_vm._v("\n                          " + _vm._s(item.fullName) + "\n                        ")]) : (item.instagramHandle) ? _c('span', [_vm._v("\n                          " + _vm._s(item.instagramHandle) + "\n                        ")]) : _c('span', [_vm._v("\n                          " + _vm._s(item) + "\n                        ")])]
      }
    }, {
      key: "item",
      fn: function(ref) {
        var item = ref.item;

        return [_c('social-handle-view', {
          attrs: {
            "divClassName": "d-inline",
            "isTikTok": item.platform === 'tiktok',
            "isInstagram": !item.platform || item.platform === 'instagram',
            "isYoutube": item.platform === 'youtube',
            "isFacebook": item.platform === 'facebook',
            "isLinkedIn": item.platform === 'linkedin',
            "isXiaohongshu": item.platform === 'xiaohongshu',
            "tiktokHandle": item.instagramHandle,
            "instagramHandle": item.instagramHandle,
            "youtubeHandle": item.instagramHandle,
            "facebookHandle": item.instagramHandle,
            "linkedinHandle": item.linkedinHandle || item.instagramHandle,
            "xiaohongshuHandle": item.fullName,
            "isOthers": item.platform === 'others',
            "otherHandle": item.instagramHandle
          }
        })]
      }
    }], null, false, 952534873),
    model: {
      value: (_vm.lemonHandle),
      callback: function($$v) {
        _vm.lemonHandle = $$v
      },
      expression: "lemonHandle"
    }
  }) : _c('v-autocomplete', {
    attrs: {
      "items": _vm.pairedInfluencers,
      "item-text": "instagramHandle",
      "item-value": "instagramHandle",
      "hide-details": "auto",
      "label": "Influencers",
      "prefix": "@",
      "dense": "",
      "outlined": ""
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(ref) {
        var item = ref.item;

        return [(item.platform === 'lemon8') ? _c('span', [_vm._v("\n                          " + _vm._s(item.fullName) + "\n                        ")]) : (item.instagramHandle) ? _c('span', [_vm._v("\n                          " + _vm._s(item.instagramHandle) + "\n                        ")]) : _c('span', [_vm._v("\n                          " + _vm._s(item) + "\n                        ")])]
      }
    }, {
      key: "item",
      fn: function(ref) {
        var item = ref.item;

        return [_c('social-handle-view', {
          attrs: {
            "divClassName": "d-inline",
            "isTikTok": item.platform === 'tiktok',
            "isInstagram": !item.platform || item.platform === 'instagram',
            "isYoutube": item.platform === 'youtube',
            "isFacebook": item.platform === 'facebook',
            "isLinkedIn": item.platform === 'linkedin',
            "isXiaohongshu": item.platform === 'xiaohongshu',
            "tiktokHandle": item.instagramHandle,
            "instagramHandle": item.instagramHandle,
            "youtubeHandle": item.instagramHandle,
            "facebookHandle": item.instagramHandle,
            "linkedinHandle": item.linkedinHandle || item.instagramHandle,
            "xiaohongshuHandle": item.fullName,
            "isOthers": item.platform === 'others',
            "otherHandle": item.instagramHandle
          }
        })]
      }
    }], null, false, 952534873),
    model: {
      value: (_vm.lemonHandle),
      callback: function($$v) {
        _vm.lemonHandle = $$v
      },
      expression: "lemonHandle"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.targetCountries,
      "item-text": "name",
      "item-value": "name",
      "label": "Country",
      "dense": "",
      "outlined": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.lemonCountry),
      callback: function($$v) {
        _vm.lemonCountry = $$v
      },
      expression: "lemonCountry"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12",
      "xs": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Lemon8 Link"
    },
    model: {
      value: (_vm.lemonLink),
      callback: function($$v) {
        _vm.lemonLink = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "lemonLink"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12",
      "xs": "12"
    }
  }, [_c('upload-media', {
    attrs: {
      "accept": "*",
      "listMedia": _vm.media,
      "influencer": _vm.influencer,
      "campaign": _vm.campaignData
    },
    on: {
      "change": _vm.lemonMediaChanged
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12",
      "xs": "12"
    }
  }, [_c('v-menu', {
    ref: "datePicker",
    attrs: {
      "close-on-content-click": false,
      "nudge-right": 40,
      "transition": "scale-transition",
      "offset-y": "",
      "min-width": "290px"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-text-field', _vm._g({
          attrs: {
            "placeholder": "Live Date",
            "append-icon": "event",
            "readonly": "",
            "dense": ""
          },
          model: {
            value: (_vm.lemonLiveDate),
            callback: function($$v) {
              _vm.lemonLiveDate = $$v
            },
            expression: "lemonLiveDate"
          }
        }, on))]
      }
    }], null, false, 3797069012),
    model: {
      value: (_vm.lemonLiveCal),
      callback: function($$v) {
        _vm.lemonLiveCal = $$v
      },
      expression: "lemonLiveCal"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "type": "date"
    },
    on: {
      "input": function($event) {
        _vm.lemonLiveCal = false
      }
    },
    model: {
      value: (_vm.lemonLiveDate),
      callback: function($$v) {
        _vm.lemonLiveDate = $$v
      },
      expression: "lemonLiveDate"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12",
      "xs": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "type": "number",
      "label": "Followers"
    },
    model: {
      value: (_vm.lemonFollowers),
      callback: function($$v) {
        _vm.lemonFollowers = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "lemonFollowers"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Views",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.lemonInsights.views),
      callback: function($$v) {
        _vm.$set(_vm.lemonInsights, "views", _vm._n($$v))
      },
      expression: "lemonInsights.views"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Average Watch Time",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.lemonInsights.watches),
      callback: function($$v) {
        _vm.$set(_vm.lemonInsights, "watches", $$v)
      },
      expression: "lemonInsights.watches"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Likes",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.lemonInsights.like_count),
      callback: function($$v) {
        _vm.$set(_vm.lemonInsights, "like_count", _vm._n($$v))
      },
      expression: "lemonInsights.like_count"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Saves",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.lemonInsights.bookmarks),
      callback: function($$v) {
        _vm.$set(_vm.lemonInsights, "bookmarks", _vm._n($$v))
      },
      expression: "lemonInsights.bookmarks"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Comments",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.lemonInsights.comment_count),
      callback: function($$v) {
        _vm.$set(_vm.lemonInsights, "comment_count", _vm._n($$v))
      },
      expression: "lemonInsights.comment_count"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Shares",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.lemonInsights.shares),
      callback: function($$v) {
        _vm.$set(_vm.lemonInsights, "shares", _vm._n($$v))
      },
      expression: "lemonInsights.shares"
    }
  })], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    on: {
      "click": function($event) {
        return _vm.addLemonInsightsManually()
      }
    }
  }, [_vm._v("Add")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.showPanel === 'story') ? _c('v-expansion-panel', [_c('v-expansion-panel-header', [_c('p', {
    staticClass: "title"
  }, [_vm._v("Add Multiple Contents")])]), _vm._v(" "), _c('v-expansion-panel-content', [_c('i', {
    staticClass: "subtitle"
  }, [_vm._v("This method is to upload multiple contents without full insights data. (Can update the insights after uploaded)")]), _c('br'), _vm._v(" "), _c('v-row', {
    staticClass: "mt-1",
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [(_vm.campaignData.campaignType === _vm.campaignTypes.AOK) ? _c('v-combobox', {
    attrs: {
      "items": _vm.pairedInfluencers,
      "item-text": "instagramHandle",
      "item-value": "instagramHandle",
      "hide-details": "auto",
      "label": "Influencers",
      "prefix": "@",
      "dense": "",
      "outlined": ""
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(ref) {
        var item = ref.item;

        return [(item.platform === 'xiaohongshu') ? _c('span', [_vm._v("\n                          " + _vm._s(item.fullName) + "\n                        ")]) : (item.instagramHandle) ? _c('span', [_vm._v("\n                          " + _vm._s(item.instagramHandle) + "\n                        ")]) : _c('span', [_vm._v("\n                          " + _vm._s(item) + "\n                        ")])]
      }
    }, {
      key: "item",
      fn: function(ref) {
        var item = ref.item;

        return [_c('social-handle-view', {
          attrs: {
            "divClassName": "d-inline",
            "isTikTok": item.platform === 'tiktok',
            "isInstagram": !item.platform || item.platform === 'instagram',
            "isYoutube": item.platform === 'youtube',
            "isFacebook": item.platform === 'facebook',
            "isLinkedIn": item.platform === 'linkedin',
            "isXiaohongshu": item.platform === 'xiaohongshu',
            "tiktokHandle": item.instagramHandle,
            "instagramHandle": item.instagramHandle,
            "youtubeHandle": item.instagramHandle,
            "facebookHandle": item.instagramHandle,
            "linkedinHandle": item.linkedinHandle || item.instagramHandle,
            "xiaohongshuHandle": item.fullName,
            "isOthers": item.platform === 'others',
            "otherHandle": item.instagramHandle
          }
        })]
      }
    }], null, false, 2946995003),
    model: {
      value: (_vm.multipleIgHandle),
      callback: function($$v) {
        _vm.multipleIgHandle = $$v
      },
      expression: "multipleIgHandle"
    }
  }) : _c('v-autocomplete', {
    attrs: {
      "items": _vm.pairedInfluencers,
      "item-text": "instagramHandle",
      "item-value": "instagramHandle",
      "hide-details": "auto",
      "label": "Influencers",
      "prefix": "@",
      "dense": "",
      "outlined": ""
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(ref) {
        var item = ref.item;

        return [(item.platform === 'xiaohongshu') ? _c('span', [_vm._v("\n                          " + _vm._s(item.fullName) + "\n                        ")]) : (item.instagramHandle) ? _c('span', [_vm._v("\n                          " + _vm._s(item.instagramHandle) + "\n                        ")]) : _c('span', [_vm._v("\n                          " + _vm._s(item) + "\n                        ")])]
      }
    }, {
      key: "item",
      fn: function(ref) {
        var item = ref.item;

        return [_c('social-handle-view', {
          attrs: {
            "divClassName": "d-inline",
            "isTikTok": item.platform === 'tiktok',
            "isInstagram": !item.platform || item.platform === 'instagram',
            "isYoutube": item.platform === 'youtube',
            "isFacebook": item.platform === 'facebook',
            "isLinkedIn": item.platform === 'linkedin',
            "isXiaohongshu": item.platform === 'xiaohongshu',
            "tiktokHandle": item.instagramHandle,
            "instagramHandle": item.instagramHandle,
            "youtubeHandle": item.instagramHandle,
            "facebookHandle": item.instagramHandle,
            "linkedinHandle": item.linkedinHandle || item.instagramHandle,
            "xiaohongshuHandle": item.fullName,
            "isOthers": item.platform === 'others',
            "otherHandle": item.instagramHandle
          }
        })]
      }
    }], null, false, 2946995003),
    model: {
      value: (_vm.multipleIgHandle),
      callback: function($$v) {
        _vm.multipleIgHandle = $$v
      },
      expression: "multipleIgHandle"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.targetCountries,
      "item-text": "name",
      "item-value": "name",
      "label": "Country",
      "hide-details": "",
      "dense": ""
    },
    model: {
      value: (_vm.multipleCountry),
      callback: function($$v) {
        _vm.multipleCountry = $$v
      },
      expression: "multipleCountry"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12",
      "xs": "12"
    }
  }, [_c('v-menu', {
    ref: "datePicker",
    attrs: {
      "close-on-content-click": false,
      "nudge-right": 40,
      "transition": "scale-transition",
      "offset-y": "",
      "min-width": "290px"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-text-field', _vm._g({
          attrs: {
            "placeholder": "Live Date",
            "append-icon": "event",
            "readonly": "",
            "dense": ""
          },
          model: {
            value: (_vm.multipleLiveDate),
            callback: function($$v) {
              _vm.multipleLiveDate = $$v
            },
            expression: "multipleLiveDate"
          }
        }, on))]
      }
    }], null, false, 895853665),
    model: {
      value: (_vm.multipleLiveCal),
      callback: function($$v) {
        _vm.multipleLiveCal = $$v
      },
      expression: "multipleLiveCal"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "type": "date"
    },
    on: {
      "input": function($event) {
        _vm.multipleLiveCal = false
      }
    },
    model: {
      value: (_vm.multipleLiveDate),
      callback: function($$v) {
        _vm.multipleLiveDate = $$v
      },
      expression: "multipleLiveDate"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "text-center",
    attrs: {
      "cols": "12",
      "md": "12",
      "xs": "12"
    }
  }, [_c('upload-media', {
    attrs: {
      "accept": "*",
      "listMedia": _vm.media,
      "influencer": _vm.influencer,
      "campaign": _vm.campaignData
    },
    on: {
      "change": _vm.mediaChanged
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', _vm._l((_vm.gdriveFiles), function(gd, index) {
    return _c('v-col', {
      key: index,
      attrs: {
        "cols": "12",
        "md": "6",
        "xs": "6"
      }
    }, [_c('v-btn', {
      staticClass: "ims-action btn-gdrive-del",
      attrs: {
        "color": "error",
        "small": ""
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.deletegDriveFile(index)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "small": ""
      }
    }, [_vm._v("close")])], 1), _vm._v(" "), _c('iframe', {
      staticClass: "media-iframe",
      attrs: {
        "width": "100%",
        "height": "100%",
        "src": gd.embedURL,
        "allowFullScreen": ""
      }
    })], 1)
  }), 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    on: {
      "click": function($event) {
        return _vm.saveMutlipleContents()
      }
    }
  }, [_vm._v("Add")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.showPanel === 'post') ? _c('v-expansion-panel', [_c('v-expansion-panel-header', [_c('p', {
    staticClass: "title"
  }, [_vm._v("Add using Instagram Graph API")]), _vm._v(" "), _c('p', {
    staticClass: "subtitle"
  }, [_vm._v("(Recommended)")])]), _vm._v(" "), _c('v-expansion-panel-content', [_c('i', {
    staticClass: "subtitle"
  }, [_vm._v("This method is officially supported by Instagram. It is required approved permissions from the influencers who logged in via Facebook.")]), _c('br'), _vm._v(" "), _c('v-text-field', {
    staticClass: "mb-5",
    attrs: {
      "height": "30px",
      "prefix": "@",
      "hide-details": "",
      "placeholder": "Filter by instagram handle"
    }
  }), _vm._v(" "), _vm._l((_vm.pairedInfluencers), function(influencer, index) {
    return _c('v-chip', {
      key: index,
      staticClass: "ma-1",
      attrs: {
        "outlined": "",
        "pill": "",
        "small": "",
        "color": "primary",
        "label": ""
      },
      on: {
        "click": function($event) {
          return _vm.showRecentPosts(influencer.instagramHandle)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "small": "",
        "left": ""
      }
    }, [_vm._v("mdi-instagram")]), _vm._v("\n                  " + _vm._s(influencer.fullName) + "(" + _vm._s(influencer.instagramHandle) + ")\n                ")], 1)
  })], 2)], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": "",
      "disabled": _vm.loading
    },
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_vm._v("Done")])], 1)], 1)], 1), _vm._v(" "), _c('Loading', {
    attrs: {
      "dialog": _vm.loading
    }
  }), _vm._v(" "), _c('PostView', {
    attrs: {
      "selectedPostIds": _vm.selectedPostIds,
      "value": _vm.recentPostDialog,
      "title": _vm.postListTitle,
      "posts": _vm.listPosts
    },
    on: {
      "onSelect": _vm.postSelected,
      "prev_page": function($event) {
        return _vm.showRecentPosts(_vm.selectedInstagramHandle, 'prev')
      },
      "next_page": function($event) {
        return _vm.showRecentPosts(_vm.selectedInstagramHandle, 'next')
      }
    },
    model: {
      value: (_vm.recentPostDialog),
      callback: function($$v) {
        _vm.recentPostDialog = $$v
      },
      expression: "recentPostDialog"
    }
  }), _vm._v(" "), _c('upload-stats-modal', {
    attrs: {
      "value": _vm.uploadStatsDialog,
      "postType": _vm.aiPostType,
      "imagesToView": _vm.campaignPayout
    },
    on: {
      "statsConfirmed": _vm.confirmedStats
    },
    model: {
      value: (_vm.uploadStatsDialog),
      callback: function($$v) {
        _vm.uploadStatsDialog = $$v
      },
      expression: "uploadStatsDialog"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3346f83a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/scoped/campaign/AddPostToCampaign.vue
// module id = 2071
// module chunks = 0